export default function flowStepper() {
  const stepperElementClass = '.js-stepper';
  const stepperNumberElementClass = '.js-stepper-item';
  const stepperLineElementClass = '.js-stepper-line';
  const cssStepperNumberActive = 'o-stepper__number--active';
  const cssStepperLineHalfFill = 'o-stepper__line--half';
  const cssStepperLineFullFill = 'o-stepper__line--full';

  function createStepper(wrap) {
    const activeNumber = parseFloat(wrap.dataset.activeNumber, 10);
    const activeIndex = Math.trunc(activeNumber) - 1;

    const stepsList = wrap.querySelectorAll(stepperNumberElementClass);
    const activeStep = stepsList[activeIndex];

    const lineList = wrap.querySelectorAll(stepperLineElementClass);

    if (activeStep) {
      activeStep.classList.add(cssStepperNumberActive);
    }

    lineList.forEach((line, index) => {
      if (activeNumber - 1 - index === 0.5) {
        line.classList.add(cssStepperLineHalfFill);
      }
      if (activeNumber - 1 > index + 0.5) {
        line.classList.add(cssStepperLineFullFill);
      }
    });

    stepsList.forEach((step, index) => {
      if (index < activeIndex) {
        step.innerText = '';
      }
    });
  }

  const stepperList = document.body.querySelectorAll(stepperElementClass);

  stepperList.forEach((stepperWrap) => createStepper(stepperWrap));
}
